import {
  API_URL,
  IS_PROD,
} from '../utils/constants';
import Config from '../config';

const QUERY_PARAMS = IS_PROD
  ? new URLSearchParams({
    per_page: '100',
  })
  : new URLSearchParams({
    per_page: '100',
    v: Date.now(),
  });

const useApiActions = () => {
  const serializeHomepage = page => ({
    introduction: page.acf.introduction,
    resources: page.acf.resources.map(r => r['resource_link']),
  });

  const getHomepage = async () => {
    const FRONT_PAGE_ID = 116;
    try {
      const res = await fetch(`${API_URL}/wp/v2/pages/${FRONT_PAGE_ID}`);
      const data = await res.json();
      return serializeHomepage(data);
    } catch (error) {
      console.error(`📣: getHomepage -> error`, error);
    }
  };

  const serializeNavLink = link => {
    return {
      link: link.slug ? `/${link.slug}` : link.url,
      linkText: link.display_title,
      themeClass: link.theme_type === 'class' ? link.theme_class_name : '',
      themeColors: link.theme_type === 'custom' ? link.theme_custom_colors : null,
    };
  };

  const getNavLinks = async () => {
    try {
      const res = await fetch(`${API_URL}/art-direction-show/v1/menu/top-nav?${QUERY_PARAMS}`);
      const data = await res.json();
      return data.map(serializeNavLink);
    } catch (error) {
      console.error(`📣: getNavLinks -> error`, error);
    }
  };

  const serializeFooterLink = link => {
    return {
      link: link.slug ? `/${link.slug}` : link.url,
      linkText: link.title,
    };
  };

  const getFooterLinks = async () => {
    try {
      const res = await fetch(`${API_URL}/art-direction-show/v1/menu/footer?${QUERY_PARAMS}`);
      const data = await res.json();
      return data.map(serializeFooterLink);
    } catch (error) {
      console.error(`📣: getFooterLinks -> error`, error);
    }
  };

  const serializeIssue = issue => {
    return {
      path: `/${issue.slug}`,
      header: issue.acf.header,
      title: issue.title.rendered,
      description: issue.acf.description,
      content: issue.content.rendered,
      footer: issue.acf.footer,
      themeClass: issue.acf.theme_type === 'class' ? issue.acf.theme_class_name : '',
      themeColors: issue.acf.theme_type === 'custom' ? issue.acf.theme_custom_colors : null,
      artwork: issue.acf.artwork_type === 'code' ? Config.pageArtwork[issue.slug] : null,
      topLeftArtwork: issue.acf.artwork_type === 'custom' ? issue.acf.top_left_artwork : null,
      bottomRightArtwork:
        issue.acf.artwork_type === 'custom' ? issue.acf.bottom_right_artwork : null,
      image: issue.featured_image_url,
      type: issue.type,
    };
  };

  const getIssues = async () => {
    try {
      const res = await fetch(`${API_URL}/wp/v2/issue?${QUERY_PARAMS}`);
      const data = await res.json();
      return data.map(serializeIssue).reverse();
    } catch (error) {
      console.error(`📣: getIssues -> error`, error);
    }
  };

  const serializeInterview = interview => {
    return {
      path: `/interviews/${interview.slug}`,
      header: interview.acf.header,
      title: interview.title.rendered,
      description: interview.acf.description,
      content: interview.content.rendered,
      summary: interview.acf.summary,
      image: interview.featured_image_url,
      type: interview.type,
    };
  };

  const getInterviews = async () => {
    try {
      const res = await fetch(`${API_URL}/wp/v2/interview?${QUERY_PARAMS}`);
      const data = await res.json();
      return data.map(serializeInterview);
    } catch (error) {
      console.error(`📣: getInterviews -> error`, error);
    }
  };

  const serializePost = (post, parentPath = null) => {
    return {
      path: parentPath ? `/${parentPath}/${post.slug}` : `/${post.slug}`,
      title: post.title.rendered,
      content: post.content.rendered,
      excerpt: post.excerpt.rendered,
      image: post.featured_image_url,
      themeColors: post.acf && post.acf.theme_colors,
      type: post.type,
    };
  };

  const getPostsByCategory = async (categoryId, parentPath) => {
    try {
      const res = await fetch(
        `${API_URL}/wp/v2/posts?categories=${categoryId}&${QUERY_PARAMS}`,
      );
      const data = await res.json();
      return data.map(post => serializePost(post, parentPath));
    } catch (error) {
      console.error(`📣: getPosts -> error`, error);
    }
  };

  return {
    getHomepage,
    getNavLinks,
    getFooterLinks,
    getIssues,
    getInterviews,
    getPostsByCategory,
  };
};

export default useApiActions;
